import {ADD_NOTIFICATION} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

export default function streamConfigReducer(state = initialState.notification, action) {
  let newState;

  switch (action.type) {

    case ADD_NOTIFICATION:

        newState = objectAssign({}, state, {
          message: action.message,
          level: action.level
        })

      return newState;

    default:
    //console.debug('notification reducer :: hit default', action.type);
      return state;
  }
}
